import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaPhoneVolume,
  FaWhatsapp,
  FaInstagram,
  FaPaperPlane,
} from "react-icons/fa6";
import { CiFacebook } from "react-icons/ci";
import { MdEmail } from "react-icons/md";
import { motion } from "framer-motion";

const Contact = ({ contactTheme }) => {
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const formContainerVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        delay: 0.4,
      },
    },
  };

  const sendContact = (e) => {
    e.preventDefault();
    const fullname = document.getElementById("fullname").value;
    const email = document.getElementById("email").value;
    const message = document.getElementById("message").value;

    if (fullname && email && message) {
      setIsSending(true);

      fetch("https://andromeda-backend.vercel.app/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_FORM_KEY,
        },
        body: JSON.stringify({
          fullname,
          email,
          message,
          client_id: process.env.REACT_APP_FORK_SECRET,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setIsSending(false);
          if (data.ok) {
            setIsSent(true);
            document.getElementById("fullname").value = "";
            document.getElementById("email").value = "";
            document.getElementById("message").value = "";

            setTimeout(() => {
              setIsSent(false);
            }, 3000);
          } else {
            alert(
              "Errore nell'invio del messaggio. Riprovare o contattateci telefonicamente.",
            );
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setIsSending(false);
          alert(
            "Errore nell'invio del messaggio. Riprovare o contattateci telefonicamente.",
          );
        });
    } else {
      alert("Per favore, compila tutti i campi.");
    }
  };

  const bgColor = contactTheme === "dark" ? "bg-[#1f2127]" : "bg-white";
  const textColor = contactTheme === "dark" ? "text-white" : "text-[#333333]";

  return (
    <section id="contact" className={`w-full ${bgColor} z-10 py-12`}>
      <div className="max-w-[1500px] mx-auto">
        <motion.div
          className="flex flex-col md:flex-row justify-center"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div
            variants={itemVariants}
            className={`w-full md:w-1/3 p-8 ${textColor}`}
          >
            <motion.h1
              variants={itemVariants}
              className="text-[#406580] text-[12px] font-bold tracking-widest"
            >
              Marrocco ART
            </motion.h1>
            <motion.h2 variants={itemVariants} className="text-4xl font-bold">
              Indirizzo
            </motion.h2>
            <motion.p variants={itemVariants} className="mt-4">
              Via Luigi Einaudi, 10, 00047 Marino RM, Italia
            </motion.p>

            <motion.div
              variants={itemVariants}
              className="flex items-center mt-8"
            >
              <motion.div
                whileHover={{ scale: 1.2 }}
                className="mr-4 text-[#406580] text-2xl"
              >
                <a href="tel:+3423971162">
                  <FaPhoneVolume />
                </a>
              </motion.div>
              <div>
                <h3 className="text-[12px] tracking-widest">PREVENTIVI</h3>
                <p className="text-[#406580]">+39 342 397 1162</p>
              </div>
            </motion.div>

            <motion.div
              variants={itemVariants}
              className="flex items-center mt-4"
            >
              <motion.div
                whileHover={{ scale: 1.2 }}
                className="mr-4 text-[#406580] text-2xl"
              >
                <a href="mailto:info@marroccoart.it">
                  <MdEmail />
                </a>
              </motion.div>
              <div>
                <h3 className="text-[12px] tracking-widest">DOMANDE</h3>
                <a className="text-[#406580]" href="mailto:info@marroccoart.it">
                  info@marroccoart.it
                </a>
              </div>
            </motion.div>

            <motion.div
              variants={itemVariants}
              className="flex items-center mt-8 space-x-4"
            >
              <motion.a
                href="tel:+3423971162"
                whileHover={{ y: -5 }}
                transition={{ type: "spring", stiffness: 400 }}
              >
                <div className="text-[#406580] text-2xl p-3 bg-gray-100 rounded-full shadow hover:shadow-md">
                  <FaWhatsapp />
                </div>
              </motion.a>
              <motion.a
                href="https://www.instagram.com/marroccogroup/"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -5 }}
                transition={{ type: "spring", stiffness: 400 }}
              >
                <div className="text-[#406580] text-2xl p-3 bg-gray-100 rounded-full shadow hover:shadow-md">
                  <FaInstagram />
                </div>
              </motion.a>
              <motion.a
                href="https://www.facebook.com/people/Marrocco-Group/61552063162756/?sk=reels_tab"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -5 }}
                transition={{ type: "spring", stiffness: 400 }}
              >
                <div className="text-[#406580] text-2xl p-3 bg-gray-100 rounded-full shadow hover:shadow-md">
                  <CiFacebook />
                </div>
              </motion.a>
            </motion.div>
          </motion.div>

          <motion.div
            variants={formContainerVariants}
            className="w-full md:w-2/3 p-8"
          >
            <div className="relative">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.6 }}
                className="absolute inset-0 border-2 border-[#1d506b] rounded-lg translate-x-2 -translate-y-2 transform pointer-events-none z-0"
              />
              <motion.form
                className="mt-2 bg-[#406580] p-6 md:p-8 rounded-lg relative z-10 shadow-lg"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8, duration: 0.8 }}
              >
                <div className="relative flex flex-col md:flex-row gap-4">
                  <motion.div
                    className="w-full md:w-1/2"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 1.0, duration: 0.5 }}
                  >
                    <label className="text-white font-medium" htmlFor="name">
                      Nome Completo
                    </label>
                    <input
                      className="w-full mt-2 p-3 rounded-md border-2 border-transparent focus:border-white focus:outline-none transition-all duration-300"
                      type="text"
                      id="fullname"
                      name="name"
                      placeholder="John Doe"
                    />
                  </motion.div>
                  <motion.div
                    className="w-full md:w-1/2"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 1.0, duration: 0.5 }}
                  >
                    <label className="text-white font-medium" htmlFor="email">
                      Email
                    </label>
                    <input
                      className="w-full mt-2 p-3 rounded-md border-2 border-transparent focus:border-white focus:outline-none transition-all duration-300"
                      type="email"
                      id="email"
                      name="email"
                      placeholder="example@test.com"
                    />
                  </motion.div>
                </div>
                <motion.div
                  className="mt-4 relative"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 1.2, duration: 0.5 }}
                >
                  <label className="text-white font-medium" htmlFor="message">
                    Messaggio
                  </label>
                  <textarea
                    className="w-full mt-2 p-3 rounded-md border-2 border-transparent focus:border-white focus:outline-none transition-all duration-300 min-h-[150px]"
                    id="message"
                    name="message"
                    rows="4"
                    placeholder="Il tuo messaggio..."
                  ></textarea>
                </motion.div>

                <motion.div
                  className="mt-6 flex justify-center"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 1.4, duration: 0.5 }}
                >
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className={`px-8 py-3 rounded-full text-black font-medium flex items-center justify-center space-x-2 
                              ${isSent ? "bg-green-400" : "bg-white"} shadow-lg hover:shadow-xl transition-all duration-300`}
                    onClick={sendContact}
                    disabled={isSending || isSent}
                  >
                    {isSending ? (
                      <div className="flex items-center space-x-2">
                        <div className="w-5 h-5 border-2 border-[#406580] border-t-transparent rounded-full animate-spin"></div>
                        <span>Invio in corso...</span>
                      </div>
                    ) : isSent ? (
                      <div className="flex items-center space-x-2">
                        <svg
                          className="w-5 h-5 text-green-900"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 13l4 4L19 7"
                          ></path>
                        </svg>
                        <span>Messaggio Inviato!</span>
                      </div>
                    ) : (
                      <div className="flex items-center space-x-2">
                        <FaPaperPlane className="text-[#406580]" />
                        <span>Invia Messaggio</span>
                      </div>
                    )}
                  </motion.button>
                </motion.div>
              </motion.form>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
